<template>
  <b-card-actions action-collapse title="Booking list">
     <b-row> 
      <b-col md="12">
  
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
    class="booking-list"
      ref="table-client"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
            <b-dropdown-item @click="updateBookingState(props.row._id,'accepted')" v-if="props.row.state !== 'accepted'">
                <feather-icon icon="CheckIcon" class="mr-50" />
                <span>Accept Booking</span>
              </b-dropdown-item>
              <b-dropdown-item @click="updateBookingState(props.row._id,'refused')" v-if="props.row.state!=='refused'">
                <feather-icon icon="XIcon" class="mr-50" />
                <span>Refuse Booking</span>
              </b-dropdown-item>
              <b-dropdown-item @click="detailQuotation(props.row.quotation._id)">
                <feather-icon icon="ExternalLinkIcon" class="mr-50" />
                <span>Detail quotation</span>
              </b-dropdown-item>
              <b-dropdown-item @click="updateBooking(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Update Booking</span>
              </b-dropdown-item>
              <b-dropdown-item @click="DeleteBooking(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete Booking</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else-if="props.column.field == 'customer'">
        <p v-if="props.row.customer">{{ props.row.customer.email }} <br> {{ props.row.customer.customer.firstName }} {{ props.row.customer.customer.lastName }}</p>
      </span>
      <span v-else-if="props.column.field == 'commodity'">
        <button class="show-button" v-b-modal="'commodity'" @click="showCommodity(props.row.commodityContainer)">View Details</button>
      </span>
        <span v-else-if="props.column.field == 'container'">
          <button class="show-button" v-b-modal="'container'" @click="showContainer(props.row.commodityContainer)">View Details</button>
        </span>
        <span v-else-if="props.column.field == 'pdf'">
        <div class="file">
          <b-form-file
            placeholder ="PDF"
            type="file"
            v-model="file"
            name="file"
            accept=".pdf"
          ></b-form-file>
          <b-button size="sm" variant="gradient-primary" class="file-button" @click="uploadFile(props.row._id)">
            <feather-icon icon="SaveIcon" size="18"/>
          </b-button>
        </div>
        <b-button class="mt-1" v-if="props.row.pdf" @click="downloadFile(props.row.pdf)">Download File</b-button>
      </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal id="commodity" size="xl" hide-footer centered  title="Commodity"><commodity :data="comData"></commodity></b-modal>
    <b-modal id="container" size="xl" hide-footer centered  title="Container"><container :data="containerData"></container></b-modal>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
  BFormFile
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import moment from 'moment';
import commodity from "./BookingCommodity.vue"
import container from "./BookingContainer.vue"
export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    commodity,
    container,
    BFormFile
  },
  data() {
    return {
      file : null,
      comData : [],
      containerData : [],
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      pageLength: 5,
      dir: false,
      hm: null,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
          {
          label: "State",
          field: "state",
          filterOptions: {
            enabled: true,
            placeholder: "State",
          },
        },
        {
          label: "Customer",
          field: "customer",
          filterOptions: {
            enabled: true,
            placeholder: "Customer",
          },
        },
        {
          label: "Reference",
          field: "reference",
          filterOptions: {
            enabled: true,
            placeholder: "Reference",
          },
        },
        {
          label: "Quotation",
          field: "quotation.reference",
          filterOptions: {
            enabled: true,
            placeholder: "Quotation",
          },
        },
        {
          width: "150px",
          label: "Loading Port",
          field: "loadingPort",
          filterOptions: {
            enabled: true,
            placeholder: "Loading Port",
          },
        },
        {
          width: "170px",
          label: "Discharge Port",
          field: "dischargePort",
          filterOptions: {
            enabled: true,
            placeholder: "Discharge Port",
          },
        },
        {
          label: 'Incoterm',
          field: 'incoterm',
          filterOptions: {
            enabled: true,
            placeholder: 'Incoterm',
          },
        },
        {
          width: "170px",
          label: 'Transport Type',
          field: 'transportType',
          filterOptions: {
            enabled: true,
            placeholder: 'Transport Type',
          },
        },
        {
          width: "230px",
          label: 'Address departure city',
          field: 'departureAddressCity',
          filterOptions: {
            enabled: true,
            placeholder: 'Address departure city',
          },
        },
        {
          width: "200px",
          label: 'Address arrival city',
          field: 'arrivalAddressCity',
          filterOptions: {
            enabled: true,
            placeholder: 'Address arrival city',
          },
        },
        {
          width: "170px",
          label: 'Commodity',
          field: 'commodity',
        },
        {
          width: "170px",
          label: 'Container',
          field: 'container',
        },
        {
          width: "170px",
          label: "Effective Date",
          field: "effectiveDate",
          filterOptions: {
            enabled: true,
            placeholder: "Effective Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          width: "170px",
          label: "Expiry Date",
          field: "expiryDate",
          filterOptions: {
            enabled: true,
            placeholder: "Expiry Date",
          },
          formatFn: (value) => {
            return moment(value).format('MM/DD/YYYY');
          },
        },
        {
          width: "170px",
          label: "Customer Code",
          field: "customerCode",
          filterOptions: {
            enabled: true,
            placeholder: "Customer Code",
          }
        },
        {
          width: "180px",
          label: "Company Name",
          field: "companyName",
          filterOptions: {
            enabled: true,
            placeholder: "Company Name",
          }
        },
        {
          label: "Country",
          field: "country",
          filterOptions: {
            enabled: true,
            placeholder: "Country",
          }
        },
        {
          width: "170px",
          label: "Postal/Zip code",
          field: "zipCode",
          filterOptions: {
            enabled: true,
            placeholder: "Postal/Zip code",
          }
        },
        {
          width: "170px",
          label: "Street Name",
          field: "streetName",
          filterOptions: {
            enabled: true,
            placeholder: "Street Name",
          }
        },
        {
          width: "170px",
          label: "Street Number",
          field: "streetNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Street Number",
          }
        },
        {
          width: "170px",
          label: "P.O. Box",
          field: "POBox",
          filterOptions: {
            enabled: true,
            placeholder: "P.O. Box",
          }
        },
        {
          width: '350px',
          label: "PDF",
          field: "pdf",
        }, 
      ],
      rows: [],
      searchTerm: "",
      nameState: null,
    };
  },
  async created() {
    await this.getAllDataBooking();
  },
  computed: {
  },
  methods: {
    async getAllDataBooking() {
      if (this.$router.history.current.query.text === "voyage") {
        const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/voyages?id="+this.$router.history.current.query.id
        );
        this.rows = response.data.data.bookings;
      }
      else {
        const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/transshipment?id="+this.$router.history.current.query.id
        );
        this.rows = response.data.data.bookings;
      }
    },
    showCommodity(item) {
      this.comData = item
    },
    showContainer(item) {
      this.containerData = item
    },
    async uploadFile(id) {
      if (!this.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Please select a file`,
            icon: "UserIcon",
            variant: "warning",
          },
        });      
      }
      else {
        const allowedExtensions = ['.pdf'];
        const fileExtension = this.file.name.slice(this.file.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `PDF file only`,
              icon: "UserIcon",
              variant: "warning",
            },
          }); 
        }
        else {
          const formData = new FormData();
          formData.append("pdf",this.file)
          try {
            const response = await axios.put(`https://mtl-feeder-nodejs.onrender.com/api/bookings/${id}`, formData ,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              });
              this.getAllDataBooking()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `File submitted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });             
            } catch (error) {
              console.error(error);
            }
        }
      }
    },
    downloadFile(url) {
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = "File.pdf";  
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    DeleteBooking(id) {
      this.$swal({
        title: "you really want to delete this booking ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .put(
              `https://mtl-feeder-nodejs.onrender.com/api/bookings/${id}`, { active : false }
            )
            .then((response) => {
              this.getAllDataBooking();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Booking deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    updateBookingState(id,newState) {
        axios
        .put(
          `https://mtl-feeder-nodejs.onrender.com/api/bookings/${id}`, { state : newState })
        .then((response) => {
          this.getAllDataBooking()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "booking update",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    updateBooking(id) {
      var routerLink = "/sale/booking/edit?id=" + id;
      this.$router.replace(routerLink);
    },
    detailQuotation(id) {
      var routerLink = "/sale/quotations/booking/quotation-detail?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.booking-list .vgt-table.bordered td {
  text-align: center;
  vertical-align: middle !important;
}
.booking-list .vgt-table.bordered td:last-child {
  text-align: left;
}
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}
.custom-containers-popup {
  width: 45em !important;
  padding: 35px 0 !important;
}
.custom-booking-popup {
  width: 100em !important;
  padding: 35px 0 !important;
}
.booking-table td {
  padding: 10px 0 !important;
}
.booking-table th {
  padding: 10px !important
}
.booking-table td:nth-child(2) {
  text-align: left !important;
  padding: 10px !important
}
.container-table th {
  padding: 10px 20px !important
}
.container-table td {
  padding: 10px 12px !important;
}
.booking-table td , .booking-table th,.container-table td , .container-table th{
  border : 1px solid #ebe9f1 !important;
}
.confirm-button {
  margin-top: 20px !important;
}
.booking-list .vgt-table td:nth-child(10),.booking-list .vgt-table td:nth-child(11) {
  text-align: center !important;
}
.show-button {
  border: 1px solid #6e6b7b !important;
  color: #6e6b7b !important;
  background-color: transparent !important;
  border-radius: 3px !important;
  padding: 5px 20px !important;
  font-weight: bold !important;
}
.file {
  display: flex;
  align-items: center;
}
.file-button {
  margin-left: 10px;
}
</style>
